import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var top = /*#__PURE__*/css(["margin:", " 0;", ";"], pxToRem(spacing.md), mediaQuery({
  min: minBreakpoints.L
}, css(["transform:translateY(", ");margin:0;"], pxToRem(spacing.xl))));
export var bottom = /*#__PURE__*/css(["transform:translateY(-", ");", ""], pxToRem(spacing.lg), mediaQuery({
  min: minBreakpoints.L
}, css(["transform:translateY(-", ");"], pxToRem(spacing.xl))));
export var imageContainer = /*#__PURE__*/css(["display:flex;position:relative;width:100%;box-sizing:border-box;"]);
export var image = /*#__PURE__*/css(["width:100%;box-shadow:0 ", " ", " 0 rgba(0,0,0,0.2);border-radius:", ";overflow:hidden;height:auto;"], pxToRem(4), pxToRem(8), pxToRem(10));
export var ar11 = /*#__PURE__*/css(["aspect-ratio:1 / 1;"]);
export var ar43 = /*#__PURE__*/css(["aspect-ratio:4 / 3;"]);
export var ar169 = /*#__PURE__*/css(["aspect-ratio:16 / 9;"]);
export var arAuto = /*#__PURE__*/css(["aspect-ratio:auto;"]);